<template>
  <div class="banner-page flex-center">
    <el-carousel height="440px" :interval="6000">
      <el-carousel-item v-for="(item, index) in data" :key="index">
        <el-image style="width: 100%;height: 100%; cursor: pointer;" :src="item.bannerImage" fit="cover" @click="bannerLink(item)" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
    }
  },
  methods: {
    bannerLink(val) {
      window.open(val.url, '__blank')
    }
  }
}
</script>

<style scoped>

.banner-page {
  width: 100%;
  height: 100%;
}

.el-carousel {
  width: 100%;
}

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }

</style>

<style lang="scss" scoped>
.el-carousel {
  width: 100%;

  /deep/ .el-carousel__button {
    width: 5px;
    height: 5px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 2px;
  }
  /deep/ .is-active .el-carousel__button {
    // 指示器激活按钮
    width: 5px;
    opacity: 1;
    border-radius: 3px;
    background: #fff;
  }
  /deep/ .el-carousel__arrow--left {
    left: 0px !important;
    border-radius: 0px 4px 4px 0px;
    background-color: #000000;
    opacity: 0.36;
  }
  /deep/ .el-carousel__arrow {
    border: none;
    outline: none;
    padding: 0;
    margin: 0;

    cursor: pointer;
    transition: 0.3s;
    color: #ffffff;
    position: absolute;
    top: 50%;
    z-index: 10;
    transform: translateY(-50%);
    text-align: center;
    font-size: 14px;
    width: 20px;
    height: 32px;
  }
  /deep/ .el-carousel__arrow:hover {
    background-color: #000000;
    opacity: 0.8;
  }
  /deep/ .el-carousel__arrow--right {
    right: 0px !important;
    border-radius: 4px 0px 0px 4px;
    background-color: #000000;
    opacity: 0.36;
  }
}

</style>
